import React, { useEffect, useMemo, useState } from "react";
import "./analytics-float.css";

export default function AnalyticsFloat({ onOpen }) {
  const [active, setActive] = useState(null);   
  const [loading, setLoading] = useState(true);

  const fetchActive = async () => {
    try {
      const r = await fetch(`/api/analytics/active?t=${Date.now()}`, { cache: "no-store" });
      const data = await r.json();
      setActive(typeof data?.visitors === "number" ? data.visitors : null);
    } catch {
      setActive(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActive();
    const timer = setInterval(fetchActive, 30000); 
    return () => clearInterval(timer);
  }, []);

  const label = useMemo(() => {
    if (loading) return "…";
    if (active == null) return "—";
    return active;
  }, [loading, active]);

  return (
    <button className="afloat" onClick={onOpen} title="View analytics">
      <div className="afloat__dot" />
      <div className="afloat__content">
        <div className="afloat__value">{label}</div>
        <div className="afloat__text">Now Online</div>
      </div>
    </button>
  );
}
